/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderPlusIcon16Solid = forwardRef('FolderPlusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.5A1.5 1.5 0 0 1 2.5 2h3.3a1.5 1.5 0 0 1 1.205.607L8.037 4H12.5A2.5 2.5 0 0 1 15 6.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 11.5v-8Zm6 3.2a.7.7 0 0 1 .7-.7h.6a.7.7 0 0 1 .7.7V8h1.3a.7.7 0 0 1 .7.7v.6a.7.7 0 0 1-.7.7H9v1.3a.7.7 0 0 1-.7.7h-.6a.7.7 0 0 1-.7-.7V10H5.7a.7.7 0 0 1-.7-.7v-.6a.7.7 0 0 1 .7-.7H7V6.7Z" })));
});
